import React from 'react';
import { Message } from 'semantic-ui-react'

const termsAndConditions = () => (
    <div style={{width:'100%'}}>
  <Message> 
     
      <Message.Header>
<h3>Terms & Conditions</h3>
       </Message.Header>
       <p> Our website is a Portal where anyone can submit their website’s link to get the Benefits of quality back links and fast search engine rankings. But we have some set some rules you need to understand and follow. </p>

<Message.Header>
By registering an account in our website, you are bound to our Following Terms and Condition:
</Message.Header>
<p>
      <li>By Submit Content to us granted us permission us to publish, display, modify, and distribute your content Online.</li>
      <li>If you use any words related to prohibition than we have right to delete it without informing you. Content is Strictly Prohibited if –</li>
    <ul>○ You Use of Foul or abusive words, Threat or harasses</ul>
   <ul> ○ Content is Spam</ul>
   <ul> ○ Child abuse etc</ul>
   <ul> ○ If Content involuntary Pornography or Nudity</ul>
   <ul> ○ Content contains Confidential Information</ul> 

</p>

<Message.Header>
If you don’t follow these conditions, even after warning then we can Temporary or permanently suspend your account.
</Message.Header>
<p>
• You cannot Submit Other Link of other brands here without the Confirmation of the Owner of those Product/Services. If we get Complaint we will not only delete your submissions but your account will also be got banned. <br/>
• We will send you a new password on request but if there’s any Complication regarding Password changes we are not responsible. In this case, create a new Account.<br/>
• Selecting a wrong category even after submitting the Multiple right Posts, we have right to ban your account.<br/>
• If you want to delete a Submission by sending us a request by email using your Official ID, we will delete it in 5 working days or in a month if there’s complication. If your Submission is still at our website then there can be many reasons such as we never received your mail.
<br/>
</p>

<p>
<strong>Note</strong> - We reserve all rights to Change Terms and Condition or Guidelines of our website any time without any notice.
</p>
<Message.Header>
Security
</Message.Header>

<Message.Header>
Disclaimer (copyright)
</Message.Header>
<p>
All Rights of thundersocialbookmarking are Reserved under the Copyright © thundersocialbookmarking.com All Rights Reserved, No Part of this website can be Reproduced or stored in any form by all means without the permission of Publisher.
</p>
      </Message>
</div>
);
export default termsAndConditions;